import { ReactComponent as HomeIcon } from '../../assets/menuIcons/001-home.svg';
import { ReactComponent as CustomersIcon } from '../../assets/menuIcons/002-customers.svg';
import { ReactComponent as ProductsIcon } from '../../assets/menuIcons/003-products.svg';
import { ReactComponent as AwardsIcon } from '../../assets/menuIcons/004-awards.svg';
import { ReactComponent as CodesIcon } from '../../assets/menuIcons/005-codes.svg';
import { ReactComponent as ReportsIcon } from '../../assets/menuIcons/006-reports.svg';
import { ReactComponent as SettingsIcon } from '../../assets/menuIcons/007-settings.svg';
import { ReactComponent as LocationsIcon } from '../../assets/menuIcons/008-locations.svg';
import { ReactComponent as AccountIcon } from '../../assets/menuIcons/009-account.svg';
import { ReactComponent as SupportIcon } from '../../assets/menuIcons/010-support.svg';
import { ReactComponent as LogOutIcon } from '../../assets/menuIcons/011-log-out.svg';

export const MenuIconIndex = {
    home: HomeIcon,
    group: CustomersIcon,
    coins: ProductsIcon,
    award: AwardsIcon,
    QRcode: CodesIcon,
    clipboard: ReportsIcon,
    cog: SettingsIcon,
    mapLocation: LocationsIcon,
    user: AccountIcon,
    questionMark: SupportIcon,
    signOut: LogOutIcon,
};
